var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.562,
    height: 12.128,
    viewBox: "99 89 7.562 12.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m101.996 95.064 4.566-4.566L105.063 89 99 95.064l6.063 6.064 1.499-1.498-4.566-4.566Z",
    fill: "#533ffb",
    fillRule: "evenodd",
    "data-name": "icons8-back"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowPurple);
export default __webpack_public_path__ + "static/media/left_arrow_purple.5b25fad1e84cd8aa33b5a0d74c0b8f49.svg";
export { ForwardRef as ReactComponent };